module.exports = __webpack_public_path__ + "img/infoImg6.abd17597.png";